export default "__VITE_ASSET__CPuiq8je__"